import { render, staticRenderFns } from "./Comentario.vue?vue&type=template&id=1ae50bc8&scoped=true"
import script from "./Comentario.vue?vue&type=script&lang=js"
export * from "./Comentario.vue?vue&type=script&lang=js"
import style0 from "./Comentario.vue?vue&type=style&index=0&id=1ae50bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae50bc8",
  null
  
)

export default component.exports